module.exports = __webpack_public_path__ + "img/Tra-Khrut-JPEG.bd55ccc4.jpg";